import FormSelect from './FormSelect'
// TODO: Move this file to @catalog
// eslint-disable-next-line no-restricted-imports
import useCatalogs from '@catalog/client/composables/useCatalogs'

export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({
        options: [],
        multiple: false,
        searchable: true,
        label: 'label',
        trackBy: 'value',
      }),
    },
  },
  setup () {
    const { catalogsList, fetchCatalogs } = useCatalogs()

    return { catalogsList, fetchCatalogs }
  },
  mounted () {
    this.fetchCatalogs()
  },
  computed: {
    catalogsOptions () {
      return this.catalogsList.map(catalog => ({
        label: catalog.displayName,
        value: catalog.id,
      }))
    },
    normalizedOptions () {
      return this.catalogsOptions
    },
  },
}
